import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import Util from "@/util";

Vue.use(Vuex);

const state = {
  id_laman$: Util.ls.get("id_laman$"),
  periode$: "",
  load: true,
  status: {
    loading: false,
    type: null,
    message: null
  },
  processing: false,
  upload_progress: 100,
  ui: {
    layout: "Public",
    rightSidebar: false,
    sidebar: Util.ls.get("sidebar") || true,
    sidebar_mini: Util.ls.get("sidebar_mini") || true,
    themeColor: Util.ls.get("themeColor") || "blue",
    lightOption: Util.ls.get("lightOption") || "light"
  }
};

const getters = {
  laman$(state, getters, rootState) {
    return rootState.laman.laman.find(l => l.id_laman == state.id_laman$).laman;
  }
};

const mutations = {
  PROCESSING(state, bool = true) {
    state.processing = bool;
  },
  LOADING(state) {
    state.status = {
      loading: true,
      type: "",
      message: ""
    };
  },
  LOADING_DONE(state) {
    state.status = {
      loading: false,
      type: "",
      message: ""
    };
  },
  SUCCESS(state, payload) {
    state.status = {
      loading: false,
      type: "success",
      message: payload
    };
    state.processing = false;
  },
  ERROR(state, payload) {
    state.status = {
      loading: false,
      type: "error",
      message: payload
    };
    state.processing = false;
  },
  INFO(state, payload) {
    state.status = {
      loading: false,
      type: "info",
      message: payload
    };
    state.processing = false;
  },
  WARNING(state, payload) {
    state.status = {
      loading: false,
      type: "warning",
      message: payload
    };
    state.processing = false;
  },
  UPLOAD_PROGRESS(state, value) {
    state.upload_progress = value;
  },
  TOGGLE_RELOAD(state) {
    state.load = !state.load;
  },
  SET_PERIODE(state, value) {
    state.periode$ = value;
  },
  SET_LAMAN(state, value) {
    state.id_laman$ = value;
  },
  SET_LAYOUT(state, isPublic) {
    state.ui.layout = isPublic ? "Public" : "Private";
  },
  SET_RIGHT_SIDEBAR(state, value) {
    state.ui.rightSidebar = value;
  },
  SET_SIDEBAR(state, value) {
    state.ui.sidebar = value;
  },
  SET_SIDEBAR_MINI(state, value) {
    state.ui.sidebar_mini = value;
  },
  SET_THEME_COLOR(state, value) {
    state.ui.themeColor = value;
  },
  SET_LIGHT_OPTION(state, value) {
    state.ui.lightOption = value;
  }
};

const actions = {
  SET_LAMAN({ commit }, payload) {
    Util.ls.set("id_laman$", payload);
    commit("SET_LAMAN", payload);
  },
  SET_SIDEBAR({ commit }, payload) {
    Util.ls.set("sidebar", payload);
    commit("SET_SIDEBAR", payload);
  },
  SET_SIDEBAR_MINI({ commit }, payload) {
    Util.ls.set("sidebar_mini", payload);
    commit("SET_SIDEBAR_MINI", payload);
  },
  SET_THEME_COLOR({ commit }, payload) {
    Util.ls.set("themeColor", payload);
    commit("SET_THEME_COLOR", payload);
  },
  SET_LIGHT_OPTION({ commit }, payload) {
    Util.ls.set("lightOption", payload);
    commit("SET_LIGHT_OPTION", payload);
  }
};

export default new Vuex.Store({
  modules: modules,
  strict: false,
  state,
  getters,
  mutations,
  actions
});
